import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Divider, Grid, FormControl, FormControlLabel, Checkbox, Button, Typography, Radio, RadioGroup, Tooltip, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import SaveIcon from "@material-ui/icons/Save";
import GetAppIcon from "@material-ui/icons/GetApp";
import CalculatorIcon from "../../layout/CalculatorIcon";
import CustomAcordion from "../../layout/CustomAcordion";
import ArrowBackIcon from "@material-ui/icons/ArrowBackIos";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import CustomLink from "../../layout/CustomLink";
import LabeledTextField from "../../layout/LabeledTextField";
import helpTexts from "../../../assets/texts/helpTexts";
import HelpDialog from "../../layout/HelpDialog";
import HasRabinovichDialog from "../../shared/dialogs/HasRabinovichDialog";
import DepreciationCalculatorDialog from "./dialogs/depreciationCalculatorDialog";
import PrisaComponent from "../../shared/prisaComponent";
import { getAmountOptions } from "../../../services/utils/utils";
import fileService from "../../../services/docsService/filesService";
import { AttachFile } from "@material-ui/icons";
import Swal from "sweetalert2";
import filesService from "../../../services/docsService/filesService";
import dealsService from "../../../services/dealsService";
import config from "../../../config";

class DealMainCalc extends Component {
  state = {
    dialogs: {
      dialogPart: 0,
      hasRabinovichDialogOpen: false,
      depreciationCalculatorDialogOpen: false
    },
    isManualOptionsShown:
      this.props.overrideTkufaPercent && Object.values(this.props.overrideTkufaPercent).some((val) => val) ? true : false,
    isDepreciationAddedSnackbarOpen: false
  };

  render() {
    const allowsRabinovich = this.props.preCalc.propertyType !== "sharesInUnion";
    const purchaseParts = this.props.deductions.map((deduction, index) => {
      let content;
      if (deduction.deduType === "purchase") {
        const currencyOpts = this.getCurrencyOptions(deduction.deduDate);
        content = (
          <CustomAcordion summaryText={`פרטי רכישה מספר ${index + 1}`} defaultExpanded={true}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Grid container direction="row" spacing={5} alignItems="center">
                  <Grid item>
                    <LabeledTextField
                      type="date"
                      label="תאריך הרכישה"
                      name="deduDate"
                      assistantPath={`deals.calc.mainCalc.deductions[${index}].deduDate`}
                      textFieldWidth={170}
                      onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                      value={deduction.deduDate}
                    />
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" spacing={1} alignItems="center">
                      <Grid item>
                        <LabeledTextField
                          type="number"
                          label="סכום הרכישה במטבע המקורי"
                          name="amount"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].amount`}
                          textFieldWidth={140}
                          helpDialog={helpTexts.purchaseAmountInOriginalCurrency}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          value={deduction.amount}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="select"
                          name="deduCurrency"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].deduCurrency`}
                          textFieldWidth={112}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          value={deduction.deduCurrency}
                          options={currencyOpts}
                          background
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {allowsRabinovich && deduction.deduDate < "2004-01-01" && deduction.deduDate > "2001-11-06" ? (
                <Fragment>
                  <Grid item>
                    <Divider light />
                  </Grid>
                  <Grid item>
                    <FormControl fullWidth component="fieldset">
                      <Grid container direction="column" alignItems="flex-start">
                        <Grid item>
                          <FormControlLabel
                            labelPlacement="end"
                            control={
                              <Checkbox
                                checked={deduction.hasRabinovich}
                                value={!deduction.hasRabinovich}
                                onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                                name="hasRabinovich"
                                color="primary"
                              />
                            }
                            label="מס האם זכאי להנחה במס שבח, בגין רכישה שבוצעה בתקופה הקובעת, לפי סעיף 48א(ד1)?"
                          />
                        </Grid>
                        <Grid item>
                          <CustomLink
                            label="בדוק זכאות"
                            onClick={() => {
                              this.openDialog("hasRabinovichDialogOpen", index);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Fragment>
              ) : null}
            </Grid>
          </CustomAcordion>
        );
      } else if (deduction.deduType === "inheritance") {
        const propertyPurchaseDate = this.props.getPurchaseDate(deduction);
        const currencyOpts = this.getCurrencyOptions(propertyPurchaseDate);
        content = (
          <CustomAcordion summaryText={`פרטי רכישה מספר ${index + 1}`} defaultExpanded={true}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Grid container direction="row" spacing={5} alignItems="center">
                  <Grid item>
                    <LabeledTextField
                      type="date"
                      label="תאריך פטירת המוריש"
                      name="testatorPassingDate"
                      textFieldWidth={170}
                      onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                      value={deduction.testatorPassingDate}
                    />
                  </Grid>
                  {deduction.testatorPassingDate >= "1981-04-01" ? (
                    <Grid item>
                      <LabeledTextField
                        type="date"
                        label="תאריך הרכישה של המוריש"
                        name="testatorBoughtPropertyDate"
                        textFieldWidth={170}
                        onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        value={deduction.testatorBoughtPropertyDate}
                      />
                    </Grid>
                  ) : null}
                  <Grid item>
                    {deduction.testatorPassingDate ? (
                      <Grid container direction="row" spacing={1} alignItems="center">
                        <Grid item>
                          <LabeledTextField
                            type="number"
                            label={
                              deduction.testatorPassingDate >= "1981-04-01"
                                ? "סכום הרכישה של המוריש במטבע המקורי"
                                : 'שווי הרכישה ביום פטירת המוריש, במטבע המקורי, עפי דו"ח העזבון'
                            }
                            name="amount"
                            assistantPath={`deals.calc.mainCalc.deductions[${index}].amount`}
                            helpDialog={helpTexts.purchaseAmountInOriginalCurrency}
                            textFieldWidth={140}
                            onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                            value={deduction.amount}
                          />
                        </Grid>
                        <Grid item>
                          <LabeledTextField
                            type="select"
                            name="deduCurrency"
                            assistantPath={`deals.calc.mainCalc.deductions[${index}].deduCurrency`}
                            textFieldWidth={112}
                            onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                            value={deduction.deduCurrency}
                            options={currencyOpts}
                            background
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
              {allowsRabinovich && deduction.testatorBoughtPropertyDate < "2004-01-01" && deduction.testatorBoughtPropertyDate > "2001-11-06" ? (
                <Fragment>
                  <Grid item>
                    <Divider light />
                  </Grid>
                  <Grid item>
                    <FormControl fullWidth component="fieldset">
                      <Grid container direction="column" alignItems="flex-start">
                        <Grid item>
                          <FormControlLabel
                            labelPlacement="end"
                            control={
                              <Checkbox
                                checked={deduction.hasRabinovich}
                                value={!deduction.hasRabinovich}
                                onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                                name="hasRabinovich"
                                color="primary"
                              />
                            }
                            label="מס האם זכאי להנחה במס שבח, בגין רכישה שבוצעה בתקופה הקובעת, לפי סעיף 48א(ד1)?"
                          />
                        </Grid>
                        <Grid item>
                          <CustomLink
                            label="בדוק זכאות"
                            onClick={() => {
                              this.openDialog("hasRabinovichDialogOpen", index);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Fragment>
              ) : null}
            </Grid>
          </CustomAcordion>
        );
      } else if (deduction.deduType === "gift") {
        const currencyOpts = this.getCurrencyOptions(deduction.deduDate);
        content = (
          <CustomAcordion summaryText={`פרטי רכישה מספר ${index + 1}`} defaultExpanded={true}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Grid container direction="row" spacing={5} alignItems="center">
                  <Grid item>
                    <LabeledTextField
                      type="date"
                      label="תאריך הרכישה של נותן המתנה"
                      name="deduDate"
                      assistantPath={`deals.calc.mainCalc.deductions[${index}].deduDate`}
                      textFieldWidth={170}
                      onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                      value={deduction.deduDate}
                    />
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" spacing={1} alignItems="center">
                      <Grid item>
                        <LabeledTextField
                          type="number"
                          label="סכום הרכישה של נותן המתנה במטבע המקורי"
                          name="amount"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].amount`}
                          textFieldWidth={140}
                          helpDialog={helpTexts.purchaseAmountInOriginalCurrency}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          value={deduction.amount}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="select"
                          name="deduCurrency"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].deduCurrency`}
                          textFieldWidth={112}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          value={deduction.deduCurrency}
                          options={currencyOpts}
                          background
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {allowsRabinovich && deduction.deduDate < "2004-01-01" && deduction.deduDate > "2001-11-06" ? (
                <Fragment>
                  <Grid item>
                    <Divider light />
                  </Grid>
                  <Grid item>
                    <FormControl fullWidth component="fieldset">
                      <Grid container direction="column" alignItems="flex-start">
                        <Grid item>
                          <FormControlLabel
                            labelPlacement="end"
                            control={
                              <Checkbox
                                checked={deduction.hasRabinovich}
                                value={!deduction.hasRabinovich}
                                onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                                name="hasRabinovich"
                                color="primary"
                              />
                            }
                            label="מס האם זכאי להנחה במס שבח, בגין רכישה שבוצעה בתקופה הקובעת, לפי סעיף 48א(ד1)?"
                          />
                        </Grid>
                        <Grid item>
                          <CustomLink
                            label="בדוק זכאות"
                            onClick={() => {
                              this.openDialog("hasRabinovichDialogOpen", index);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Fragment>
              ) : null}
            </Grid>
          </CustomAcordion>
        );
      }
      return content ? (
        <Grid key={`purchse-details-${index + 1}`} item>
          {content}
        </Grid>
      ) : null;
    });

    const deductionImportActions = (
      <Fragment>
        <label htmlFor="deduction-template">
          <span className="main-calc-deduction-action pointer rotate45">
            העלאת ניכויים
            <AttachFile />
          </span>
        </label>
        <input
          id="deduction-template"
          style={{ visibility: "hidden", position: "absolute" }}
          type="file"
          onChange={this.onUploadDeductionFile}
        />
        <span
          onClick={() =>
            fileService.downloadDeductionTemplate(() => {
              Swal.fire("לא ניתן להוריד את הקובץ כרגע", "יש לנסות מאוחר יותר", "warning");
            })
          }
          className="main-calc-deduction-action pointer"
        >
          הורדת ניכויים
          <GetAppIcon />
        </span>
      </Fragment>
    );

    const firstExpenseIndex = this.props.deductions.findIndex((deduction) => !dealsService.isPurchaseDeduction(deduction.deduType));
    const hasPurchaseSection = firstExpenseIndex !== 0;
    const hasBothSections = firstExpenseIndex > 0;

    const depreciations = (
      <Grid item>
        <CustomAcordion summaryText="ניכויים" summaryActions={deductionImportActions} defaultExpanded={true}>
          <Grid container direction="column" spacing={1}>
            {this.props.deductions.map((deduction, index) => {
              let propertyPurchaseDate;
              if (deduction.deduType === "inheritance") {
                propertyPurchaseDate = this.props.getPurchaseDate(deduction);
                //   deduction.testatorPassingDate >= "1981-04-01" ? deduction.testatorBoughtPropertyDate : deduction.testatorPassingDate;
              } else {
                propertyPurchaseDate = deduction.deduDate;
              }
              const isPurchaseDeduction = dealsService.isPurchaseDeduction(deduction.deduType);
              const deduTypeOpts = dealsService.getDeductionTypeOptions();
              const deduCurrencyOpts = this.getCurrencyOptions(propertyPurchaseDate);
              const depCurrencyOpts = this.getCurrencyOptions(propertyPurchaseDate, deduction.depreciation);
              const attributionOpts = this.getAtrributionOptions();
              const belongToPartsOpts = getAmountOptions(this.props.preCalc.preCalcPartsData.length);

              const isLastDeductionRow = index === this.props.deductions.length - 1;
              const isLastPurchaseBeforeExpenses = hasBothSections && index === firstExpenseIndex - 1;

              const isPreviousPurchase =
                index > 0 && dealsService.isPurchaseDeduction(this.props.deductions[index - 1].deduType);

              return (
                <Fragment key={"temp" + index}>
                  {hasPurchaseSection && index === 0 ? (
                    <Grid item className="main-calc-deduction-section-heading is-purchases">
                      <span className="main-calc-deduction-section-heading-text">רכישות</span>
                      <span aria-hidden="true" className="main-calc-deduction-section-heading-line" />
                    </Grid>
                  ) : null}
                  {isPurchaseDeduction && isPreviousPurchase ? (
                    <Grid item className="main-calc-purchase-summary-spacer" />
                  ) : null}
                  {hasBothSections && index === firstExpenseIndex ? (
                    <Grid item className="main-calc-deduction-section-heading is-expenses">
                      <span className="main-calc-deduction-section-heading-text">הוצאות נוספות</span>
                      <span aria-hidden="true" className="main-calc-deduction-section-heading-line" />
                    </Grid>
                  ) : null}
                  {isPurchaseDeduction ? (
                    this.renderPurchaseDeductionSummary({
                      deduction,
                      index,
                      propertyPurchaseDate,
                      deduCurrencyOpts,
                      depCurrencyOpts,
                      attributionOpts,
                      belongToPartsOpts
                    })
                  ) : (
                    <Grid container item direction="row" spacing={1} alignItems="center">
                      <Grid item>
                        <LabeledTextField
                          type="select"
                          value={deduction.deduType}
                          name="deduType"
                          label={
                            <span className="main-calc-deduction-label-with-index">
                              <span aria-hidden="true" className="main-calc-purchase-summary-index">
                                {index + 1}
                              </span>
                              <span>ניכוי</span>
                            </span>
                          }
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          options={deduTypeOpts}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="date"
                          value={propertyPurchaseDate}
                          textFieldWidth={170}
                          name="deduDate"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].deduDate`}
                          label="תאריך"
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="number"
                          value={deduction.amount}
                          textFieldWidth={120}
                          name="amount"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].amount`}
                          label="סכום"
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="select"
                          value={deduction.deduCurrency}
                          textFieldWidth={112}
                          background
                          name="deduCurrency"
                          assistantPath={`deals.calc.mainCalc.deductions[${index}].deduCurrency`}
                          options={deduCurrencyOpts}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        />
                      </Grid>
                      {this.props.preCalc.sellerType === "single" && this.props.preCalc.propertyType === "dmm" ? (
                        <Grid item>
                          <LabeledTextField
                            type="select"
                            value={deduction.attribution}
                            textFieldWidth={120}
                            name="attribution"
                            options={attributionOpts}
                            label="ייחוס"
                            onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          />
                        </Grid>
                      ) : null}
                      {this.props.preCalc.stepsBought > 1 ? (
                        <Grid item>
                          <LabeledTextField
                            type="select"
                            multiple
                            value={deduction.belongToParts}
                            textFieldWidth={120}
                            name="belongToParts"
                            options={belongToPartsOpts}
                            label="חלק רכישה"
                            onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                          />
                        </Grid>
                      ) : null}
                      <Grid item>
                        <LabeledTextField
                          type="number"
                          disabled={true}
                          value={
                            deduction.depreciation && Number.isFinite(deduction.depreciation.depreciationResult)
                              ? deduction.depreciation.depreciationResult
                              : ""
                          }
                          textFieldWidth={120}
                          name="depreciationResult"
                          label="פחת"
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        />
                      </Grid>
                      <Grid item>
                        <LabeledTextField
                          type="select"
                          disabled
                          value={deduction.depreciation.depCurrency || deduction.deduCurrency}
                          textFieldWidth={112}
                          background
                          name="depCurrency"
                          options={depCurrencyOpts}
                          onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                        />
                      </Grid>
                      <Grid item>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                          <Grid item>
                            {this.renderDepreciationCalculatorButton(index, Boolean(deduction.amount && propertyPurchaseDate))}
                          </Grid>
                          <Grid item>
                            <HelpDialog label="פחת" helpDialog={helpTexts.depreciation} />
                          </Grid>
                          {(this.props.preCalc.howPropertyIsSold === "partOfPropertySold" ||
                            this.props.preCalc.howPropertyIsSold === "combination") && (
                            <Grid item>
                              <Tooltip title="בסימון אפשרות זו, ההוצאה תנוכה באופן מלא ולא באופן יחסי">
                                <Checkbox
                                  checked={deduction.applyFullDeductionAmount || false}
                                  onChange={(e) =>
                                    this.props.handleMainCalcDeductionOnChange(
                                      { target: { value: e.target.checked, name: "applyFullDeductionAmount" } },
                                      index
                                    )
                                  }
                                  color="primary"
                                />
                              </Tooltip>
                            </Grid>
                          )}
                          <Grid item>
                            <Tooltip title="מחק">
                              <DeleteIcon
                                fontSize="small"
                                style={{ cursor: "pointer", verticalAlign: "middle" }}
                                onClick={() => this.props.removeMainCalcDeduction(index)}
                              />
                            </Tooltip>
                          </Grid>
                          {(deduction.isInsertDeductionAsNegativeVaue || this.props.role === "admin") && (
                            <Grid item>
                              <FormControlLabel
                                labelPlacement="end"
                                control={
                                  <Checkbox
                                    disabled={this.props.role !== "admin"}
                                    checked={deduction.isInsertDeductionAsNegativeVaue}
                                    value={!deduction.isInsertDeductionAsNegativeVaue}
                                    onChange={(e) => this.props.handleMainCalcDeductionOnChange(e, index)}
                                    name="isInsertDeductionAsNegativeVaue"
                                    color="primary"
                                  />
                                }
                                label="ניכוי שלילי"
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {!isLastDeductionRow && !isLastPurchaseBeforeExpenses && !isPurchaseDeduction ? (
                    <Grid item className="main-calc-deduction-row-divider">
                      <Divider light />
                    </Grid>
                  ) : null}
                </Fragment>
              );
            })}
            <Grid className="main-calc-add-deduction" container item direction="row" alignItems="flex-start">
              <Button
                variant="contained"
                color="secondary"
                disabled={this.props.deductions.length >= config.maxDeductionsAllowed}
                endIcon={<AddIcon style={{ marginRight: "8px" }} />}
                onClick={this.props.addMainCalcDeduction}
              >
                הוספת ניכוי
              </Button>
            </Grid>
          </Grid>
        </CustomAcordion>
      </Grid>
    );

    const maxYears = this.props.getPrisaMaxYears();
    const minYears = this.props.getPrisaMinYears();
    const prisa =
      this.props.preCalc.sellerType === "single" ? (
        <Grid item>
          <PrisaComponent
            {...this.props.prisa}
            // isClientsNumDisabled={!this.props.abilities.includes("prisaExt")}
            isClientsNumDisabled={true}
            // isNumOfYearsDisabled={!this.props.abilities.includes("prisaExt")}
            shouldTryPrisaShown
            soldPropertyDate={this.props.preCalc.soldPropertyDate}
            maxYears={maxYears}
            minYears={minYears}
            options={getAmountOptions(6)}
            handlePrisaOnChange={this.props.handleMainCalcPrisaOnChange}
          />
        </Grid>
      ) : null;

    const anotherQuestions = (
      <Grid item>
        <CustomAcordion summaryText="שאלות נוספות" defaultExpanded={true}>
          <Grid container direction="column" spacing={2}>
            <Grid container item direction="row" spacing={10} alignItems="center">
              <Grid item>
                <LabeledTextField
                  type="number"
                  value={this.props.kizuzIski}
                  textFieldWidth={185}
                  name="kizuzIski"
                  label="קיזוז הפסד עסקי"
                  helpDialog={helpTexts.kizuzIski}
                  onChange={(e) => this.props.handleMainCalcOnChange(e)}
                />
              </Grid>
              <Grid item>
                <LabeledTextField
                  type="number"
                  value={this.props.kizuzHoni}
                  textFieldWidth={185}
                  name="kizuzHoni"
                  label="קיזוז הפסד הוני"
                  helpDialog={helpTexts.kizuzHoni}
                  onChange={(e) => this.props.handleMainCalcOnChange(e)}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Divider light />
            </Grid>
            <Grid container item direction="row" spacing={10} alignItems="center">
              <Grid item>
                <FormControl component="fieldset">
                  <Grid container item direction="row" spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" align="right">
                        חישוב המס בדרך של גילום
                      </Typography>
                    </Grid>
                    <Grid item>
                      <HelpDialog helpDialog={helpTexts.isGilum} label="חישוב המס בדרך של גילום" />
                    </Grid>
                    <Grid item>
                      <RadioGroup
                        row
                        name="isGilum"
                        value={Boolean(this.props.isGilum).toString()}
                        onChange={(e) => this.props.handleMainCalcOnChange(e)}
                      >
                        <FormControlLabel value={"true"} control={<Radio color="primary" />} label="כן" labelPlacement="end" />
                        <FormControlLabel value={"false"} control={<Radio color="primary" />} label="לא" labelPlacement="end" />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl component="fieldset">
                  <Grid container item direction="row" spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" align="right">
                        האם יש זיכוי הפקעה
                      </Typography>
                    </Grid>
                    <Grid item>
                      <HelpDialog helpDialog={helpTexts.afkaa} label="האם יש זיכוי הפקעה" />
                    </Grid>
                    <Grid item>
                      <RadioGroup
                        row
                        name="afkaa"
                        value={Boolean(this.props.afkaa).toString()}
                        onChange={(e) => this.props.handleMainCalcOnChange(e)}
                      >
                        <FormControlLabel value={"true"} control={<Radio color="primary" />} label="כן" labelPlacement="end" />
                        <FormControlLabel value={"false"} control={<Radio color="primary" />} label="לא" labelPlacement="end" />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </CustomAcordion>
      </Grid>
    );
    const dialogs = (
      <Grid item>
        {allowsRabinovich && this.state.dialogs.hasRabinovichDialogOpen ? (
          <HasRabinovichDialog
            handleResults={(e) => this.props.handleMainCalcDeductionOnChange(e, this.state.dialogs.dialogPart)}
            onClose={() => this.closeDialog("hasRabinovichDialogOpen")}
            open={true}
          />
        ) : null}
        {this.state.dialogs.depreciationCalculatorDialogOpen ? (
          <DepreciationCalculatorDialog
            handleResults={(e) => this.props.handleMainCalcDeductionOnChange(e, this.state.dialogs.dialogPart)}
            deduction={this.props.deductions[this.state.dialogs.dialogPart]}
            sellerType={this.props.preCalc.sellerType}
            propertyType={this.props.preCalc.propertyType}
            soldPropertyDate={this.props.preCalc.soldPropertyDate}
            getPurchaseDate={this.props.getPurchaseDate}
            onClose={() => this.closeDialog("depreciationCalculatorDialogOpen")}
            onAdded={() => this.handleDepreciationAdded()}
            open={true}
          />
        ) : null}
      </Grid>
    );

    const preCalcPartsData = this.props.preCalc?.preCalcPartsData;
    const needsMutav = preCalcPartsData && preCalcPartsData[0] && preCalcPartsData[0].needsMutav;
    const needsRegTax = preCalcPartsData && preCalcPartsData[0] && preCalcPartsData[0].needsRegTax;

    return (
      <Fragment>
      <Grid className="deal-main-calc" container direction="column" spacing={2}>
        <Grid className="pre-calc-sections" container item direction="column" wrap="nowrap">
          {purchaseParts}
          {depreciations}
          {prisa}
          {anotherQuestions}

          {preCalcPartsData?.length === 1 && (
            <Grid item>
              <div className="main-calc-advanced-link right">
                <Button
                  endIcon={
                    this.state.isManualOptionsShown ? (
                      <ArrowDownwardIcon style={{ marginRight: "8px" }} />
                    ) : (
                      <ArrowBackIcon style={{ marginRight: "8px" }} />
                    )
                  }
                  variant="text"
                  color="primary"
                  onClick={() => this.setState({ isManualOptionsShown: !this.state.isManualOptionsShown })}
                >
                  חישובים מתקדמים
                </Button>
              </div>

              {this.state.isManualOptionsShown && (
                <CustomAcordion className="main-calc-tax-overrides-accordion" summaryText="שינוי הגדרות חישוב עסקה" defaultExpanded>
                  <div className="main-calc-tax-overrides">
                    <div className="main-calc-tax-overrides-note">
                      <strong>הערה חשובה מאוד</strong>
                      <span>במידה ואינך יודע\ת בדיוק מה את\ה עושה אנו מאוד ממליצים לא למלא שדות אלו ולהמשיך רגיל את חישוב העסקה</span>
                    </div>
                    <p className="main-calc-tax-overrides-hint">
                      בשדות הבאים ניתן לשנות את אחוז המס לתשלום (ניתן להזין אחוז בין 1 ל-50):
                    </p>
                    <p className="main-calc-tax-overrides-hint">
                      ככל ואינך משנה שיעור מס בתקופה מסויימת - אינך נדרש למלא שדה זה.
                    </p>
                    <div className="main-calc-tax-overrides-fields">
                      {needsRegTax ? (
                        <>
                          {this.renderTaxRateOverrideField("overrideLinear47", "שבח תקופה ראשונה", 47)}
                          {this.renderTaxRateOverrideField("overrideLinear20", "שבח תקופה שניה", 20)}
                          {this.renderTaxRateOverrideField("overrideLinear25", "שבח תקופה שלישית", 25)}
                          {this.renderTaxRateOverrideField("overrideInflation10", "שבח אינפלציוני", 10)}
                        </>
                      ) : null}
                      {needsMutav ? this.renderTaxRateOverrideField("overrideMutav25", "שבח לינארי מוטב", 25) : null}
                    </div>
                  </div>
                </CustomAcordion>
              )}
            </Grid>
          )}

          {dialogs}
        </Grid>
        <Grid className="pre-calc-actions" item container direction="row" spacing={2}>
          <Grid item>
            <Button
              endIcon={<PlayArrowIcon style={{ marginRight: "8px" }} />}
              variant="contained"
              color="secondary"
              onClick={this.props.mainCalcStart}
            >
              חשב מס
            </Button>
          </Grid>
          <Grid item>
            <Button
              endIcon={<SaveIcon style={{ marginRight: "8px" }} />}
              variant="contained"
              color="secondary"
              onClick={this.props.updateDealData}
            >
              שמירה
            </Button>
          </Grid>
          {this.props.role === "admin" ? (
            <Grid item>
              <Button
                endIcon={<GetAppIcon style={{ marginRight: "8px" }} />}
                variant="contained"
                color="primary"
                onClick={this.props.exportDealData}
              >
                ייצא
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </Grid>
        <Snackbar
          open={this.state.isDepreciationAddedSnackbarOpen}
          autoHideDuration={3000}
          onClose={() => this.closeDepreciationAddedSnackbar()}
          onClick={() => this.closeDepreciationAddedSnackbar()}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert className="deal-depreciation-added-alert" severity="success" onClose={() => this.closeDepreciationAddedSnackbar()}>
            הפחת נוסף בהצלחה
          </Alert>
        </Snackbar>
      </Fragment>
    );
  }

  onUploadDeductionFile = (e) => {
    const deductionFile = e.target.files[0];
    if (!deductionFile || !deductionFile.name.toLowerCase().includes(".xlsx")) {
      Swal.fire("פורמט לא תקין", "ניתן להעלות רק את הקובץ המובנה שלנו שניתן להוריד על לחיצה על הכפתור משמאל", "warning");
      return;
    }

    Swal.fire({
      title: "להעלות קובץ עם ניכויים?",
      text: "יש להקפיד על שימוש בפורמט שלנו בלבד אחרת לא נוכל להעלות את הניכויים שלך",
      icon: "info",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        filesService.translateDeduTemplateToObj(deductionFile).then((res) => {
          document.getElementById("deduction-template").value = "";

          if (res.success) {
            this.props.addMainCalcDeductionsFromExcel(res.data);
          }
        });
      }
    });
  };

  openDialog(dialogName, part) {
    this.setState({ dialogs: { ...this.state.dialogs, [dialogName]: true, dialogPart: part || 0 } });
  }

  closeDialog(dialogName) {
    this.setState({ dialogs: { ...this.state.dialogs, [dialogName]: false, dialogPart: 0 } });
  }

  handleDepreciationAdded() {
    this.setState({
      dialogs: { ...this.state.dialogs, depreciationCalculatorDialogOpen: false, dialogPart: 0 },
      isDepreciationAddedSnackbarOpen: true
    });
  }

  closeDepreciationAddedSnackbar() {
    this.setState({ isDepreciationAddedSnackbarOpen: false });
  }

  getCurrencyOptions(date, depreciation) {
    const options = [];
    if (!date) {
      options.push({ label: "שקל חדש", value: "newShekel" });
      options.push({ label: "דולר", value: "usd" });
    } else if (depreciation && depreciation.depType === "regTax") {
      return [{ label: "שקל חדש", value: "newShekel" }];
    } else {
      if (date >= "1986-01-01") {
        options.push({ label: "שקל חדש", value: "newShekel" });
      } else if (date >= "1980-02-24") {
        options.push({ label: "שקל ישן", value: "oldShekel" });
      } else {
        options.push({ label: "לירה", value: "lira" });
      }
      if (date >= "1977-10-31") {
        options.push({ label: "דולר", value: "usd" });
      }
    }
    return options;
  }

  getPrisaYearsOptions(maxYears) {
    const options = [];
    for (let i = 1; i <= maxYears; i++) {
      options.push({ label: i === 1 ? "שנה אחת אחורה" : `${i} שנים אחורה`, value: i });
    }
    return options;
  }

  getAtrributionOptions() {
    const options = [{ label: "דירה", value: "apartment" }];
    if (this.props.preCalc.hasZaban) {
      options.push({ label: 'זב"ן', value: "zaban" });
      options.push({ label: 'דירה וזב"ן', value: "both" });
    }
    return options;
  }

  renderPurchaseDeductionSummary({
    deduction,
    index,
    propertyPurchaseDate,
    deduCurrencyOpts,
    depCurrencyOpts,
    attributionOpts,
    belongToPartsOpts
  }) {
    const purchaseDate = this.formatDeductionDisplayDate(propertyPurchaseDate);
    const purchaseAmount = this.formatDeductionDisplayAmount(deduction.amount);
    const purchaseCurrency = this.getOptionLabel(deduCurrencyOpts, deduction.deduCurrency);
    const attribution = this.getOptionLabel(attributionOpts, deduction.attribution);
    const purchaseParts = this.getOptionLabel(belongToPartsOpts, deduction.belongToParts, true);
    const depreciationAmount = this.formatDeductionDisplayAmount(
      deduction.depreciation && Number.isFinite(deduction.depreciation.depreciationResult)
        ? deduction.depreciation.depreciationResult
        : ""
    );
    const depreciationCurrency = this.getOptionLabel(depCurrencyOpts, deduction.depreciation.depCurrency || deduction.deduCurrency);
    const isCalculatorEnabled = Boolean(deduction.amount && propertyPurchaseDate);

    const isAttributionShown = this.props.preCalc.sellerType === "single" && this.props.preCalc.propertyType === "dmm";
    const isPartsShown = this.props.preCalc.stepsBought > 1;

    const facts = [
      { key: "date", label: "תאריך", value: purchaseDate },
      { key: "amount", label: "סכום", value: purchaseAmount, currency: purchaseCurrency }
    ];
    if (isAttributionShown) {
      facts.push({ key: "attribution", label: "ייחוס", value: attribution });
    }
    if (isPartsShown) {
      facts.push({ key: "parts", label: "חלק רכישה", value: purchaseParts });
    }

    return (
      <Grid item className="main-calc-purchase-summary">
        <div
          className={`main-calc-purchase-summary-main${isAttributionShown ? " has-attribution" : ""}${isPartsShown ? " has-parts" : ""}`}
        >
          <span className="main-calc-purchase-summary-index">{index + 1}</span>
          <span className="main-calc-purchase-summary-title">רכישה</span>
          {facts.map((fact) => (
            <span className={`main-calc-purchase-summary-fact is-${fact.key}`} key={fact.key}>
              <span className="main-calc-purchase-summary-fact-label">{fact.label}</span>
              <span className={`main-calc-purchase-summary-fact-value${fact.value ? "" : " is-empty"}`}>
                {this.renderPurchaseSummaryValue(fact.value, fact.currency)}
              </span>
            </span>
          ))}
          <span className="main-calc-purchase-summary-fact is-depreciation">
            <span className="main-calc-purchase-summary-fact-label">פחת</span>
            <span className={`main-calc-purchase-summary-fact-value${depreciationAmount ? "" : " is-empty"}`}>
              {this.renderPurchaseSummaryValue(depreciationAmount, depreciationCurrency)}
            </span>
          </span>
          <span className="main-calc-purchase-summary-actions">
            {this.renderDepreciationCalculatorButton(index, isCalculatorEnabled)}
            <HelpDialog label="פחת" helpDialog={helpTexts.depreciation} />
          </span>
        </div>
      </Grid>
    );
  }

  renderTaxRateOverrideField(name, label, defaultPercent) {
    return (
      <div className="main-calc-tax-overrides-field" key={name}>
        <div className="main-calc-tax-overrides-field-label">{label}</div>
        <LabeledTextField
          type="number"
          name={name}
          value={this.props.overrideTkufaPercent?.[name] || ""}
          onChange={this.onOverrideTkufaPercentChange}
          currency="%"
          textFieldWidth={120}
        />
        <div className="main-calc-tax-overrides-field-rate">{`(שיעור מס לפני שינוי: ${defaultPercent}%)`}</div>
      </div>
    );
  }

  renderPurchaseSummaryValue(value, currency) {
    if (!value) return "\u00a0";

    return (
      <>
        {value}
        {currency ? <span className="main-calc-purchase-summary-currency">{currency}</span> : null}
      </>
    );
  }

  renderDepreciationCalculatorButton(index, isEnabled) {
    return (
      <button
        className={`main-calc-depreciation-calc-btn${isEnabled ? "" : " is-disabled"}`}
        disabled={!isEnabled}
        onClick={() => {
          if (!isEnabled) return;
          this.openDialog("depreciationCalculatorDialogOpen", index);
        }}
        type="button"
      >
        <CalculatorIcon fontSize="small" />
        מחשבון פחת
      </button>
    );
  }

  formatDeductionDisplayDate(date) {
    if (!date) return "";
    const formattedDate = moment(date, ["YYYY-MM-DD", "DD/MM/YYYY"], true);
    return formattedDate.isValid() ? formattedDate.format("DD/MM/YYYY") : date;
  }

  formatDeductionDisplayAmount(amount) {
    if (!Number.isFinite(amount)) return "";
    return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  getOptionLabel(options, value, isMultiple) {
    if (!Array.isArray(options) || !options.length) return "";

    if (isMultiple && Array.isArray(value)) {
      return value
        .map((item) => options.find((option) => option.value === item)?.label)
        .filter(Boolean)
        .join(", ");
    }

    return options.find((option) => option.value === value)?.label || "";
  }

  onOverrideTkufaPercentChange = (e) => {
    let { name, value } = e.target;

    if (value > 50) return;
    if (value === 0) value = "";
    const overrideTkufaPercent = this.props.overrideTkufaPercent || {};

    this.props.handleMainCalcOnChange({ target: { name: "overrideTkufaPercent", value: { ...overrideTkufaPercent, [name]: value } } });
  };
}

const mapStateToProps = (state) => {
  return {
    abilities: state.loggedinReducer.abilities,
    role: state.loggedinReducer.role
  };
};

export default connect(mapStateToProps)(DealMainCalc);
